<template>
    <div
        :class="['component--text-icon',disabled?'text-icon__disabled':null]"
        :style="{
            width:width+'px',
            height:width+'px',
            lineHeight:width+'px',
            fontSize:width/2+'px',
            backgroundColor:disabled?'gray':color}"
        @click="handleClick"
    >{{text}}</div>
</template>

<script>
    export default {
        props: {
            text: String,
            disabled: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: "#409eff"
            },
            width: {
                type: Number,
                default: 24
            }
        },
        methods: {
            handleClick() {
                if (this.disabled) return;
                this.$emit("click");
            }
        }
    };
</script>

<style lang="scss">
    .component--text-icon {
        border-radius: 50%;
        color: white;
        font-weight: bold;
        display: inline-block;
        text-align: center;
        cursor: pointer;

        &:hover {
            opacity: 0.8;
        }

        &.text-icon__disabled{
            cursor: default;

            &:hover{
                opacity: 1;
            }
        }
    }
</style>
